import type { ReactNode } from 'react';

import { CANDIDATE_MAIL_FROM_ADDRESS } from '../constants';

import MailRecipientsDropdown, { type MailRecipientsDropdownItem } from './MailRecipientsDropdown';
import MailVariableBody from './MailVariableBody';

type MailMessageViewProps = {
  recipientSummary: string;
  recipientItems: MailRecipientsDropdownItem[];
  subject: string;
  senderName: string;
  senderEmail: string;
  body: string;
  notice?: ReactNode;
};

function Divider() {
  return <div className="h-px w-full shrink-0 bg-border" />;
}

export default function MailMessageView({
  recipientSummary,
  recipientItems,
  subject,
  senderName,
  senderEmail,
  body,
  notice,
}: MailMessageViewProps) {
  return (
    <div className="flex w-full flex-col gap-sm">
      {notice}
      <div className="flex w-full min-w-0 items-center">
        <p className="min-w-0 flex-1 truncate text-body-sm text-main">
          {recipientSummary || '送信先なし'}
        </p>
        <MailRecipientsDropdown items={recipientItems} />
      </div>
      <Divider />
      <p className="text-heading-xxs break-words text-main">{subject || '（件名なし）'}</p>
      <Divider />
      <p className="flex flex-wrap items-center gap-x-xs text-main">
        <span className="text-heading-xxs">{senderName || '未設定'}</span>
        <span className="text-body-sm">&lt;{CANDIDATE_MAIL_FROM_ADDRESS}&gt;</span>
        {senderEmail && <span className="text-body-sm text-sub">返信先: {senderEmail}</span>}
      </p>
      <Divider />
      {body.trim().length > 0 ? (
        <MailVariableBody body={body} />
      ) : (
        <p className="text-body-sm text-sub">（本文なし）</p>
      )}
    </div>
  );
}
